<app-stepper
  [step]="3"
></app-stepper>

<h2 class="mt-5 text-center text-xl-start fw-bold" *ngIf="!loading && !loadingRedirect && isRegistrationvalid">
  Ihr Angebot: {{ contractTitle }}
</h2>



<ng-container *ngIf="!loading && !loadingRedirect">

   <!-- Error message for step already completed -->
    <div class="alert alert-info mt-3" *ngIf="!isRegistrationvalid">
      <p>{{ stepCompletedErrorMessage }}</p>
    </div>
  <div class="mt-5 p-3 p-xl-5 bg-light rounded-left-top-lg rounded-xl-lg" *ngIf="isRegistrationvalid">
    <div class="contract-inner overflow-auto position-relative pe-5" #contractInner (scroll)="onContractScroll(contractInner)">
      <ng-container *ngIf="fieldGroupsContent?.length">
        <ng-container *ngFor="let group of fieldGroupsContent">
          <div [innerHTML]="sanitizeContent(group.Content)"></div>
        </ng-container>
        <div id="scrolltome"></div>
      </ng-container>
    </div>
    <div class="scroll-down mt-2 w-100 btn btn-sm btn-secondary" (click)="scrollToBottom(contractInner)">
      nach unten
      <i class="fa-regular fa-computer-mouse-scrollwheel ps-2"></i>
    </div>
  </div>
  <div [formGroup]="contractFormGroup" *ngIf="isRegistrationvalid">
    <div class="mt-3">
      <app-form-input-checkbox
        [name]="'tos'"
        [label]="'StepContract.TOS' | translate"
        [formName]="contractFormGroup"
        [formGroupName]="'tos'"
        [required]="true"
        [activated]="hasReachedBottom"
      >
      </app-form-input-checkbox>
    </div>

    <div class="mt-4 mt-xl-3 text-end" *ngIf="isRegistrationvalid">
      <app-form-button-submit
        [name]="'nextLayer'"
        [active]="isFormValid()"
        [icon]="'paper-plane'"
        [label]="'Jetzt verbindlich absenden'"
        (click)="onClickSubmitContract()"
      ></app-form-button-submit>

    </div>
  </div>
</ng-container>
